import React from 'react';

import type { RedditPostComponentsProps } from './types';

export function Body(_props: RedditPostComponentsProps): React.JSX.Element {
	return <div>Reddit Group Post Body</div>;
}
